import React from 'react';

/**
 * Banner component that displays a message below the main topbar.
 * This is a sticky element that stays at the top when scrolling.
 */
export function PredictionsBanner(): JSX.Element {
  return (
    <div
      className="tw-sticky tw-top-0 tw-z-10 tw-flex tw-items-center tw-justify-center tw-bg-gray-50 tw-border-b tw-border-gray-200 tw-px-4 tw-py-3"
      style={{ width: '100%' }}
    >
      <p style={{ margin: 0, fontSize: '14px', color: '#4b5563' }}>
        This is where you can view your live HG Insights models and get in-depth
        reports on how they are performing.
      </p>
    </div>
  );
}
